<ng-template #loadingSpinner>
  <svg
    aria-hidden="true"
    class="w-5 h-5 animate-spin text-blue-500 dark:text-blue-400 fill-gray-200 dark:fill-gray-600"
    viewBox="0 0 100 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
      fill="currentColor"
    />
    <path
      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
      fill="currentFill"
    />
  </svg>
</ng-template>

<ng-template #checkMark>
  <svg
    class="w-5 h-5 text-white dark:text-white"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M5 11.917 9.724 16.5 19 7.5"
    />
  </svg>
</ng-template>

@if (weatherLegendPopover().show) {
<div
  class="fixed z-50 max-w-[260px] p-3 bg-white dark:bg-gray-800 rounded-lg shadow-lg border-gray-200 dark:border-gray-700 transition-all -translate-y-[calc(100%+8px)]"
  animate.enter="animate-popup-enter"
  animate.leave="animate-popup-leave"
  [style.top.px]="weatherLegendPopover().pos.top"
  [style.left.px]="weatherLegendPopover().pos.left"
  (mouseenter)="onPopoverEnter()"
  (mouseleave)="onPopoverLeave()"
>
  <p
    class="font-normal text-xs 2xl:text-sm text-gray-500 dark:text-gray-300"
    [innerHTML]="weatherLegendPopover().content"
  ></p>
</div>
}

<div
  #chartContainer
  class="h-full flex flex-col bg-white rounded-lg shadow-lg dark:bg-gray-800"
  [class.fixed]="isFullscreen"
  [class.inset-0]="isFullscreen"
  [class.z-50]="isFullscreen"
  [class.rounded-none]="isFullscreen"
>
  <!-- Chart Area -->
  <div
    class="min-h-0 flex-1 flex flex-col px-2 pt-2 3xl:px-6 p-4 md:p-6 pb-0 md:pb-0"
  >
    <!-- First Line: Title, Perennial Button, Time Filter -->
    <div class="relative flex justify-between items-center">
      <!-- title, and isPerennialTree button -->
      <div>
        <!-- Left -->
        <div class="flex items-center space-x-8">
          <h6
            class="leading-none text-lg 3xl:text-2xl font-bold text-gray-900 dark:text-white pb-2"
          >
            {{ title }}
          </h6>
          <div
            class="inline-flex items-center p-0.5 space-x-0.5 ml-4 3xl:ml-5 text-xs 3xl:text-sm font-medium bg-gray-200 rounded-lg dark:bg-gray-700"
            role="tablist"
            aria-label="Chart data mode"
          >
            <button
              type="button"
              role="tab"
              [attr.aria-selected]="!isWeatherMode && !isAppliedWaterEstimateMode"
              (click)="onChartTypeModeChange('et')"
              class="px-3 py-1.5 3xl:px-4 3xl:py-2 rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 transition-colors"
              [class.text-white]="!isWeatherMode && !isAppliedWaterEstimateMode"
              [class.bg-blue-600]="!isWeatherMode && !isAppliedWaterEstimateMode"
              [class.text-gray-700]="isWeatherMode || isAppliedWaterEstimateMode"
              [class.hover:bg-gray-300]="isWeatherMode || isAppliedWaterEstimateMode"
              [class.dark:text-gray-300]="isWeatherMode || isAppliedWaterEstimateMode"
              [class.dark:hover:bg-gray-600]="isWeatherMode || isAppliedWaterEstimateMode"
            >
              ET & Precipitation
            </button>

            <div
              class="relative inline-flex items-center"
              [class.hidden]="!canViewAppliedWaterEstimate"
            >
              <button
                type="button"
                role="tab"
                [attr.aria-selected]="isAppliedWaterEstimateMode"
                (click)="onChartTypeModeChange('appliedWater')"
                class="px-3 py-1.5 pr-7 3xl:px-4 3xl:py-2 3xl:pr-8 rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 transition-colors"
                [class.text-white]="isAppliedWaterEstimateMode"
                [class.bg-blue-600]="isAppliedWaterEstimateMode"
                [class.text-gray-700]="!isAppliedWaterEstimateMode"
                [class.hover:bg-gray-300]="!isAppliedWaterEstimateMode"
                [class.dark:text-gray-300]="!isAppliedWaterEstimateMode"
                [class.dark:hover:bg-gray-600]="!isAppliedWaterEstimateMode"
              >
                Applied Water Estimate
              </button>
              <div
                class="absolute right-1.5 top-1 z-10 flex flex-col items-center pb-3"
                (focusin)="onAppliedWaterEstimateInfoEnter()"
                (focusout)="!$any($event.currentTarget).contains($event.relatedTarget) && onAppliedWaterEstimateInfoLeave()"
                (mouseenter)="onAppliedWaterEstimateInfoEnter()"
                (mouseleave)="onAppliedWaterEstimateInfoLeave()"
              >
                <button
                  type="button"
                  class="flex items-center justify-center"
                  aria-label="Applied Water Estimate information"
                >
                  <svg
                    class="w-3.5 h-3.5 cursor-pointer"
                    [class.text-blue-100]="isAppliedWaterEstimateMode"
                    [class.text-gray-500]="!isAppliedWaterEstimateMode"
                    [class.dark:text-gray-300]="!isAppliedWaterEstimateMode"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"
                    />
                  </svg>
                </button>
                <div
                  class="absolute z-20 top-5 right-1 rotate-45 w-2 h-2 border-b-0 border-r-0 bg-white border border-gray-200 dark:bg-gray-800 dark:border-gray-600 transition-opacity duration-300 ease-in-out"
                  [ngClass]="
                    isAppliedWaterEstimateInfoVisible ?
                      'opacity-100 visible'
                    : 'opacity-0 invisible'
                  "
                ></div>
                <div
                  role="tooltip"
                  class="absolute top-6 left-1/2 z-30 w-72 -translate-x-1/2 text-sm text-gray-500 bg-white border border-gray-200 rounded-lg shadow-lg dark:bg-gray-800 dark:border-gray-600 dark:text-gray-400 transition-opacity duration-300 ease-in-out"
                  [ngClass]="
                    isAppliedWaterEstimateInfoVisible ?
                      'opacity-100 visible'
                    : 'opacity-0 invisible'
                  "
                >
                  <div class="p-3 space-y-2">
                    <h3 class="font-semibold text-gray-900 dark:text-white">
                      Note:
                    </h3>
                    <p
                      class="font-normal text-sm text-gray-500 dark:text-gray-300"
                    >
                      {{ appliedWaterEstimateInfoText }} Assumptions are
                      available
                      <a
                        href="/assets/pdf/20260909_AppliedWaterEstimate_DailyET_Tool.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="text-blue-600 underline hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                        >here</a
                      >. High Med and Low are provided as a range of irrigation
                      efficiencies achievable for the field's selected
                      irrigation method. Actual irrigation efficiency is highly
                      dependent on many factors such as management, irrigation
                      system age, crop age and soil characteristics.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="relative inline-flex items-center"
              [class.hidden]="isDemoMode"
            >
              <button
                type="button"
                role="tab"
                [attr.aria-selected]="isWeatherMode"
                (click)="onChartTypeModeChange('weather')"
                class="px-3 py-1.5 pr-7 3xl:px-4 3xl:py-2 3xl:pr-8 rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 transition-colors"
                [class.text-white]="isWeatherMode"
                [class.bg-blue-600]="isWeatherMode"
                [class.text-gray-700]="!isWeatherMode"
                [class.hover:bg-gray-300]="!isWeatherMode"
                [class.dark:text-gray-300]="!isWeatherMode"
                [class.dark:hover:bg-gray-600]="!isWeatherMode"
              >
                Weather Mode
              </button>
              <div
                class="absolute right-1.5 top-1 z-10 flex flex-col items-center pb-3"
                (mouseenter)="onWeatherModeInfoEnter()"
                (mouseleave)="onWeatherModeInfoLeave()"
              >
                <button
                  type="button"
                  class="flex items-center justify-center"
                  aria-label="Weather Mode information"
                  (focus)="onWeatherModeInfoEnter()"
                  (blur)="onWeatherModeInfoLeave()"
                >
                  <svg
                    class="w-3.5 h-3.5 cursor-pointer"
                    [class.text-blue-100]="isWeatherMode"
                    [class.text-gray-500]="!isWeatherMode"
                    [class.dark:text-gray-300]="!isWeatherMode"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"
                    />
                  </svg>
                </button>
                <div
                  class="absolute z-20 top-5 right-1 rotate-45 w-2 h-2 border-b-0 border-r-0 bg-white border border-gray-200 dark:bg-gray-800 dark:border-gray-600 transition-opacity duration-300 ease-in-out"
                  [ngClass]="
                    isWeatherModeInfoVisible ?
                      'opacity-100 visible'
                    : 'opacity-0 invisible'
                  "
                ></div>
                <div
                  role="tooltip"
                  class="absolute top-6 left-1/2 z-30 w-72 -translate-x-1/2 text-sm text-gray-500 bg-white border border-gray-200 rounded-lg shadow-lg dark:bg-gray-800 dark:border-gray-600 dark:text-gray-400 transition-opacity duration-300 ease-in-out"
                  [ngClass]="
                    isWeatherModeInfoVisible ?
                      'opacity-100 visible'
                    : 'opacity-0 invisible'
                  "
                >
                  <div class="p-3 space-y-2">
                    <h3 class="font-semibold text-gray-900 dark:text-white">
                      Note:
                    </h3>
                    <p
                      class="font-normal text-sm text-gray-500 dark:text-gray-300"
                    >
                      {{ weatherModeInfoText }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Inches - Acres conversion -->
          @if(selectedclaimedField?.acres) {
          <div
            class="inline-flex items-center p-0.5 space-x-0.5 3xl:p-1 3xl:space-x-1 text-xs 3xl:text-sm font-medium bg-gray-200 rounded-lg dark:bg-gray-700"
            role="tablist"
          >
            <button
              type="button"
              role="tab"
              [attr.aria-selected]="isInchesUnit()"
              (click)="setDisplayUnit('inches')"
              class="px-2 py-1 3xl:px-3 3xl:py-1.5 rounded-md focus:outline-none transition-colors"
              [class.text-white]="isInchesUnit()"
              [class.bg-blue-600]="isInchesUnit()"
              [class.text-gray-900]="!isInchesUnit()"
              [class.hover:bg-gray-300]="!isInchesUnit()"
              [class.dark:text-gray-300]="!isInchesUnit()"
              [class.dark:hover:bg-gray-600]="!isInchesUnit()"
            >
              <span class="md:hidden">in</span>
              <span class="hidden md:inline">Inches</span>
            </button>
            <button
              type="button"
              role="tab"
              [attr.aria-selected]="isAcreFeetUnit()"
              (click)="setDisplayUnit('acreFeet')"
              class="px-2 py-1 3xl:px-3 3xl:py-1.5 rounded-md focus:outline-none transition-colors"
              [class.text-white]="isAcreFeetUnit()"
              [class.bg-blue-600]="isAcreFeetUnit()"
              [class.text-gray-900]="!isAcreFeetUnit()"
              [class.hover:bg-gray-300]="!isAcreFeetUnit()"
              [class.dark:text-gray-300]="!isAcreFeetUnit()"
              [class.dark:hover:bg-gray-600]="!isAcreFeetUnit()"
            >
              <span class="md:hidden">ac-ft</span>
              <span class="hidden md:inline">Acre-Feet</span>
            </button>
            <button
              type="button"
              role="tab"
              [attr.aria-selected]="isFeetUnit()"
              (click)="setDisplayUnit('feet')"
              class="px-2 py-1 3xl:px-3 3xl:py-1.5 rounded-md focus:outline-none transition-colors"
              [class.text-white]="isFeetUnit()"
              [class.bg-blue-600]="isFeetUnit()"
              [class.text-gray-900]="!isFeetUnit()"
              [class.hover:bg-gray-300]="!isFeetUnit()"
              [class.dark:text-gray-300]="!isFeetUnit()"
              [class.dark:hover:bg-gray-600]="!isFeetUnit()"
            >
              <span class="md:hidden">ft</span>
              <span class="hidden md:inline">Feet</span>
            </button>
          </div>
          } @if(isPerennailTree && !isWeatherMode &&
          !isAppliedWaterEstimateMode) {
          <label class="inline-flex flex-row items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              value=""
              class="sr-only"
              [checked]="isPerennialTreeMode"
              (change)="onToggleForcastingMode($event)"
            />
            <div class="flex flex-row items-center gap-3">
              <div
                class="relative w-11 h-6 rounded-full ring-4 ring-brand-soft dark:ring-brand-soft after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600"
                [class.bg-blue-600]="isPerennialTreeMode"
                [class.bg-neutral-quaternary]="!isPerennialTreeMode"
                [class.dark:bg-neutral-quaternary]="!isPerennialTreeMode"
                [class.after:translate-x-full]="isPerennialTreeMode"
                [class.after:border-buffer]="isPerennialTreeMode"
              ></div>
              <span
                class="text-xs 3xl:text-sm font-medium text-gray-900 dark:text-gray-300"
                >Perennial Tree Forecasting</span
              >
            </div>
            <app-info-popover
              [infoType]="'infoPerennialTreeForecasting'"
            ></app-info-popover>
          </label>
          }
        </div>

        @if(!isPerennialTreeMode) {
        <p
          class="mt-1 text-xs 3xl:text-sm font-medium text-gray-500 dark:text-gray-400"
        >
          {{ isAppliedWaterEstimateMode ? "Applied Water Estimate" :
          isWeatherMode ? "Weather Conditions & Forecast" : "ET Values &
          Precipitation" }}
        </p>
        } @else {
        <div class="flex items-center justify-center"></div>
        }
      </div>
      @if(isPerennialTreeMode) {
      <div
        class="relative inline-flex items-center mt-1 mb-1 text-sm 3xl:text-lg font-medium text-orange-600 dark:text-orange-400 text-center"
      >
        Your Crop ET Compared to Historical Trends
      </div>
      }
      <!-- Right -->
      <div class="flex flex-row items-center gap-2">
        <!-- Dropdown Button -->
        <div class="relative" [class.hidden]="isAppliedWaterEstimateMode">
          <button
            #dropdownButton
            id="dropdownDefaultButton"
            class="text-xs 3xl:text-sm w-full h-full font-medium text-gray-500 dark:text-gray-400 hover:text-gray-900 text-center inline-flex items-center dark:hover:text-white"
            type="button"
            (click)="toggleDropdown()"
            [class.hidden]="isPerennialTreeMode"
            [class.block]="!isPerennialTreeMode"
          >
            {{ timeRange }}
            <svg
              class="w-2.5 m-2.5 ms-1.5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 10 6"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="m1 1 4 4 4-4"
              />
            </svg>
          </button>
          <!-- Dropdown menu -->
          <div
            #dropdownMenu
            id="lastDaysdropdown"
            [class.hidden]="!isOpen"
            [class.block]="isOpen"
            class="absolute -left-20 top-8 z-50 bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700"
          >
            <ul
              class="py-2 text-xs 3xl:text-sm text-gray-700 dark:text-gray-200"
              aria-labelledby="dropdownDefaultButton"
            >
              <li
                class="cursor-pointer"
                (click)="onTimeFilterChange('Last 7 days')"
              >
                <a
                  class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  >Last 7 days</a
                >
              </li>
              <li
                class="cursor-pointer"
                (click)="onTimeFilterChange('Last 15 days')"
              >
                <a
                  class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  >Last 15 days</a
                >
              </li>
              <li
                class="cursor-pointer"
                (click)="onTimeFilterChange('Last 30 days')"
              >
                <a
                  class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  >Last 30 days</a
                >
              </li>
              <li
                class="cursor-pointer"
                (click)="onTimeFilterChange('Last 60 days')"
              >
                <a
                  class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  >Last 60 days</a
                >
              </li>
              <li
                class="cursor-pointer"
                (click)="onTimeFilterChange('All Water Year')"
              >
                <a
                  class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                  >All Water Year</a
                >
              </li>
            </ul>
          </div>
        </div>
        <!-- Download buttons -->
        <div class="flex flex-row-reverse rtl:flex-row items-center gap-2">
          @if(!isWeatherMode){ @if(!isAppliedWaterEstimateMode && (type ===
          'grower' || type === 'manager')) {
          <button
            title="Download time-series data for all fields as CSV "
            class="uppercase text-xs 3xl:text-sm font-semibold inline-flex gap-1 items-center rounded-lg bg-blue-600 text-white hover:bg-blue-700 dark:focus:ring-gray-700 px-2 py-1 3xl:px-3 3xl:py-2 disabled:cursor-not-allowed"
            (click)="downloadAllETs()"
            [disabled]="isDownloadAllDisabled()"
          >
            DOWNLOAD ALL DATA
            <svg
              class="w-5 h-5 3xl:w-6 3xl:h-6"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 15v2a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-2m-8 1V4m0 12-4-4m4 4 4-4"
              />
            </svg>
          </button>
          }} @if(!isWeatherMode){
          <button
            title="Download time-series data for a selected field as CSV"
            class="bg-blue-600 text-white text-xs 3xl:text-sm px-2 py-1 3xl:px-3 3xl:py-2 rounded-lg hover:bg-blue-700 w-full md:w-auto flex items-center gap-1 3xl:gap-2 justify-center focus:outline-none download-button"
            (click)="isAppliedWaterEstimateMode ? downloadAppliedWaterEstimate() : (type === 'grower' ? downloadET() : downloadETManagerOrEntity())"
            [disabled]="isAppliedWaterEstimateMode && !appliedWaterPreviewResult"
          >
            DOWNLOAD DATA
            <svg
              class="w-5 h-5 3xl:w-6 3xl:h-6"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 15v2a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-2m-8 1V4m0 12-4-4m4 4 4-4"
              />
            </svg>
          </button>
          } @else {
          <button
            title="Download time-series data for a selected field as CSV"
            class="uppercase text-xs 3xl:text-sm font-semibold inline-flex gap-1 items-center rounded-lg bg-blue-600 text-white hover:bg-blue-700 dark:focus:ring-gray-700 px-2 py-1 3xl:px-3 3xl:py-2"
            (click)="downloadAllWeatherData()"
            [disabled]="isDownloadAllDisabled()"
          >
            DOWNLOAD ALL WEATHER DATA
            <svg
              class="w-5 h-5 3xl:w-6 3xl:h-6"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 15v2a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-2m-8 1V4m0 12-4-4m4 4 4-4"
              />
            </svg>
          </button>
          <button
            title="Download time-series data for a selected field as CSV"
            class="uppercase text-xs 3xl:text-sm font-semibold inline-flex gap-1 items-center rounded-lg bg-blue-600 text-white hover:bg-blue-700 dark:focus:ring-gray-700 px-2 py-1 3xl:px-3 3xl:py-2"
            (click)="downloadWeatherData()"
          >
            DOWNLOAD WEATHER DATA
            <svg
              class="w-5 h-5 3xl:w-6 3xl:h-6"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 15v2a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-2m-8 1V4m0 12-4-4m4 4 4-4"
              />
            </svg>
          </button>
          }
        </div>
      </div>
    </div>
    <!-- Second Line: Chart Area -->
    <div
      #chartContainer
      id="labels-chart-container"
      class="relative min-h-0 flex-1 self-stretch overflow-hidden"
      [class.applied-water-layout]="isAppliedWaterEstimateMode"
    >
      <div
        class="relative min-w-0 min-h-0"
        [class.h-full]="!isAppliedWaterEstimateMode"
        [class.hidden]="isAppliedWaterEstimateMode"
      >
        <div #chart id="labels-chart" class="h-full"></div>
        @if (!isWeatherMode && !isEtFieldSwitchLoading && isEtDataUnavailable) {
        <div
          role="status"
          class="absolute inset-0 flex items-center justify-center bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300"
        >
          ET data unavailable for this date range.
        </div>
        } @if (isEtFieldSwitchLoading || (isWeatherMode &&
        isWeatherFieldSwitchLoading)) {
        <div
          class="absolute inset-0 z-20 flex items-center justify-center bg-white/60 dark:bg-gray-800/60 rounded-md"
        >
          <div
            class="flex items-center gap-3 text-base md:text-lg font-semibold text-gray-700 dark:text-gray-200"
          >
            <svg
              aria-hidden="true"
              class="w-8 h-8 md:w-10 md:h-10 animate-spin text-blue-500 dark:text-blue-400 fill-gray-200 dark:fill-gray-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
            <span
              >{{ isEtFieldSwitchLoading ? "Loading field data..." : "Loading
              weather data..." }}</span
            >
          </div>
        </div>
        }
        <app-graph-popover-instruction
          class="absolute z-10 right-14 top-0.5"
          [useDefaultContent]="true"
        />
        <button
          title="Toggle fullscreen"
          class="absolute z-10 right-2 top-0.5 text-gray-400 hover:text-gray-700 dark:text-gray-500 dark:hover:text-gray-200 p-0.5 rounded focus:outline-none transition-colors"
          (click)="toggleFullscreen()"
        >
          @if (!isFullscreen) {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M4 8V4h4M20 8V4h-4M4 16v4h4M20 16v4h-4"
            />
          </svg>
          } @else {
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M8 4H4v4M16 4h4v4M8 20H4v-4M16 20h4v-4"
            />
          </svg>
          }
        </button>
      </div>
      @if (isAppliedWaterEstimateMode) {
      <section
        class="min-w-0 min-h-0 rounded-lg border border-gray-200 bg-white p-3 dark:border-gray-700 dark:bg-gray-800"
        aria-label="Applied water estimate preview chart"
      >
        <div class="flex h-full min-h-0 flex-col">
          <div
            class="relative min-h-0 flex-1 overflow-hidden rounded-md bg-gray-50 dark:bg-gray-900/40"
          >
            <div
              class="absolute right-3 top-2 z-20 inline-flex items-center gap-1 rounded-md border border-gray-200 bg-white/95 p-1 shadow-sm dark:border-gray-600 dark:bg-gray-800/95"
              aria-label="Applied Water chart controls"
            >
              <button
                type="button"
                title="Reset zoom"
                aria-label="Reset Applied Water chart zoom"
                class="rounded p-1 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                (click)="resetAppliedWaterChart()"
              >
                <svg
                  class="h-4 w-4"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  aria-hidden="true"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M4 4v6h6"
                  />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M5.5 15a8 8 0 1 0 1.8-8.3L4 10"
                  />
                </svg>
              </button>
              <button
                type="button"
                title="Toggle fullscreen"
                aria-label="Toggle Applied Water chart fullscreen"
                class="rounded p-1 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                (click)="toggleFullscreen()"
              >
                <svg
                  class="h-4 w-4"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  aria-hidden="true"
                >
                  @if (!isFullscreen) {
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M4 8V4h4M20 8V4h-4M4 16v4h4M20 16v4h-4"
                  />
                  } @else {
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M8 4H4v4M16 4h4v4M8 20H4v-4M16 20h4v-4"
                  />
                  }
                </svg>
              </button>
            </div>
            <div
              #appliedWaterChart
              class="absolute inset-0 h-full w-full"
            ></div>
            @if (isAppliedWaterPreviewLoading) {
            <div
              class="absolute inset-0 z-10 flex items-center justify-center bg-white/70 text-sm font-medium text-gray-500 dark:bg-gray-900/70 dark:text-gray-300"
            >
              Loading applied water chart...
            </div>
            }
          </div>
        </div>
      </section>

      <form
        class="min-w-0 min-h-0 overflow-hidden rounded-lg border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800"
        [class.bg-gray-50]="type !== 'grower'"
        [class.dark:bg-gray-900]="type !== 'grower'"
        (submit)="$event.preventDefault(); saveAppliedWaterEstimate()"
        aria-label="Monthly applied water allocation"
      >
        <div class="flex h-full min-h-0 flex-col overflow-hidden">
          <div class="border-b border-gray-200 px-3 py-2 dark:border-gray-700">
            <div class="flex items-center justify-between gap-2">
              <h3 class="text-sm font-semibold text-gray-900 dark:text-white">
                Monthly Water Sources{{ type === "grower" ? "" : " (View Only)"
                }}
              </h3>
              @if (isAppliedWaterLoading) {
              <span
                class="text-xs font-medium text-blue-600 dark:text-blue-400"
              >
                Loading...
              </span>
              }
            </div>
          </div>

          <div
            class="applied-water-form-scroll min-h-0 flex-1 overflow-y-scroll overscroll-contain"
          >
            <table
              class="w-full text-left text-xs text-gray-600 dark:text-gray-300"
            >
              <thead
                class="sticky top-0 z-10 bg-gray-50 text-[11px] uppercase text-gray-500 dark:bg-gray-700 dark:text-gray-300"
              >
                <tr>
                  <th scope="col" class="px-2 py-2">Month</th>
                  <th scope="col" class="px-2 py-2 text-center">Irrigated</th>
                  <th scope="col" class="px-2 py-2">Surface water</th>
                  <th scope="col" class="px-2 py-2">Groundwater</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
                @for (month of appliedWaterMonths; track month.key) {
                <tr>
                  <th
                    scope="row"
                    class="whitespace-nowrap px-2 py-2 font-medium text-gray-900 dark:text-white"
                    [class.!text-gray-400]="type !== 'grower'"
                    [class.dark:!text-gray-500]="type !== 'grower'"
                  >
                    {{ month.label }}
                  </th>
                  <td class="px-2 py-2 text-center">
                    <input
                      type="checkbox"
                      class="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 disabled:cursor-not-allowed disabled:opacity-40"
                      [checked]="month.selected"
                      [disabled]="type !== 'grower' || isAppliedWaterLoading || isAppliedWaterSaving"
                      (change)="onAppliedWaterMonthSelected(month, $event)"
                      [attr.aria-label]="'Select ' + month.label"
                    />
                  </td>
                  <td class="px-2 py-2">
                    <div class="flex items-center gap-1">
                      <input
                        type="number"
                        min="0"
                        max="100"
                        step="1"
                        inputmode="decimal"
                        class="w-16 rounded-md border border-gray-300 bg-white px-2 py-1 text-right text-gray-900 focus:border-blue-500 focus:ring-blue-500 disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:disabled:border-gray-700 dark:disabled:bg-gray-800 dark:disabled:text-gray-500"
                        [value]="month.surfaceWater ?? ''"
                        [disabled]="type !== 'grower' || !month.selected || isAppliedWaterLoading || isAppliedWaterSaving"
                        (input)="onSurfaceWaterInput(month, $event)"
                        [attr.aria-label]="month.label + ' surface water percentage'"
                      />
                      <span [class.text-gray-400]="type !== 'grower'">%</span>
                    </div>
                  </td>
                  <td
                    class="px-2 py-2 font-medium text-gray-900 dark:text-white"
                    [class.!text-gray-400]="type !== 'grower'"
                    [class.dark:!text-gray-500]="type !== 'grower'"
                  >
                    {{ month.groundWater === null ? "--" : month.groundWater +
                    "%" }}
                  </td>
                </tr>
                }
              </tbody>
            </table>
          </div>

          <div
            class="flex items-center justify-end gap-3 border-t border-gray-200 px-3 py-2 dark:border-gray-700"
          >
            <button
              type="submit"
              class="rounded-lg bg-blue-600 px-4 py-2 text-xs font-semibold text-white hover:bg-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500 disabled:hover:bg-gray-300 dark:disabled:bg-gray-700 dark:disabled:text-gray-400"
              [disabled]="type !== 'grower' || !appliedWaterDirty || isAppliedWaterLoading || isAppliedWaterSaving"
            >
              {{ isAppliedWaterSaving ? "Saving..." : "Save" }}
            </button>
          </div>
        </div>
      </form>
      }
    </div>
  </div>
</div>
